import { render, staticRenderFns } from "./SampleDesign.vue?vue&type=template&id=5b384814&scoped=true&"
import script from "./SampleDesign.vue?vue&type=script&lang=js&"
export * from "./SampleDesign.vue?vue&type=script&lang=js&"
import style0 from "./SampleDesign.vue?vue&type=style&index=0&id=5b384814&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b384814",
  null
  
)

export default component.exports